import {useState} from 'react'

import profile from '../assets/profile.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {  faGithub, faLinkedinIn } from "@fortawesome/free-brands-svg-icons";
import AnimatedBlob from './AnimatedBlob';

export default function Hiro () {

    const [loaded, setLoaded] = useState(true);

    return (
        <>
        {loaded ?
        <div
            className="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-dark-500 flex flex-col items-center justify-center"
        >
            <div className="w-10 h-10 border-2 border-indigo-500 border-t-transparent rounded-full animate-spin"></div>
            <p className="mt-4 text-slate-400 text-sm tracking-wide">Loading</p>
        </div>
            :
            null
        }
        <div id="home" className="flex w-full min-h-screen flex-col md:flex-row gap-8 items-center justify-center text-white relative pt-24 pb-16">
            <div className='md:w-1/2 flex justify-center relative'>
                <AnimatedBlob />
                <img src={profile} alt="profile" onLoad={() => setLoaded(false)} className="relative z-10 drop-shadow-2xl" style={{ width: '960px', maxWidth: '90vw' }} />
            </div>
            <div className='md:w-1/2' data-aos="fade-up" data-aos-duration="800">
                <div className="flex flex-col w-full">
                    <p className="text-sm text-indigo-400 font-mono tracking-widest uppercase">Hello, world</p>
                    <h1 className="text-5xl md:text-6xl font-bold mt-3 gradient-text leading-tight">Vimal Jaiswal</h1>
                    <p className="text-xl font-medium text-slate-200 mt-3">Software Development Engineer</p>
                    <p className="text-base font-light text-slate-400 mt-4 leading-relaxed max-w-lg">I love tinkering and making cool things.</p>
                </div>
                <div className='flex mt-8 gap-4 items-center'>
                   <a href='https://github.com/vimaljais' rel="noreferrer" target="_blank" className="w-12 h-12 rounded-xl bg-dark-200 border border-slate-700/30 flex items-center justify-center hover:bg-indigo-500/10 hover:border-indigo-400/40 hover:scale-105 transition-all duration-300">
                     <FontAwesomeIcon size='lg' icon={faGithub} />
                   </a>
                   <a href='https://www.linkedin.com/in/vimaljais' rel="noreferrer" target="_blank" className="w-12 h-12 rounded-xl bg-dark-200 border border-slate-700/30 flex items-center justify-center hover:bg-indigo-500/10 hover:border-indigo-400/40 hover:scale-105 transition-all duration-300">
                     <FontAwesomeIcon size='lg' icon={faLinkedinIn} />
                   </a>
                   <div className="h-px flex-1 bg-gradient-to-r from-indigo-500/30 to-transparent ml-4"></div>
                </div>
            </div>
        </div>
        </>
    )
}
